import Vue from 'vue';
import i18n from '@/i18n';
import cookie from '@/utils/helpers/cookie';
import { Connector } from '../../backendConnector';

const state = {
  isLogged: !!cookie.getCookie(process.env.VUE_APP_COOKIE_NAME_AUTH),
  isLoginLoading: false,
  profile: {
    email: '',
    created_password: '',
    is_minarm: null,
  },
  isPasswordLoading: false,
};

function loginError() {
  Vue.prototype.$notify({
    title: i18n.t('store.login.error.title'),
    message: i18n.t('store.login.error.text'),
    type: 'error',
  });
}
const actions = {
  getProfile({ commit }) {
    const backendConnector = Connector.getInstance();
    return backendConnector.getProfile()
      .then((profile) => {
        commit('SET_PROFILE', profile);
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e);
      });
  },
  postPassword({ commit }, form) {
    commit('TOGGLE_IS_PASSWORD_LOADING');
    Connector.getInstance()
      .createPassword(form)
      .finally(() => {
        commit('TOGGLE_IS_PASSWORD_LOADING');
      });
  },
  login({ commit, dispatch }, { username, password }) {
    commit('SET_IS_LOGIN_LOADING');
    const backendConnector = Connector.getInstance();
    return backendConnector
      .login(username, password)
      .then((bearer) => {
        if (bearer) {
          return backendConnector
            .getActiveProjectToken()
            .then(async () => {
              cookie.setCookie(
                process.env.VUE_APP_COOKIE_NAME_AUTH,
                bearer,
                process.env.VUE_APP_COOKIE_DURATION,
              );
              cookie.setCookie(
                process.env.VUE_APP_COOKIE_NAME_PROJECT_ID,
                backendConnector.projectToken,
                process.env.VUE_APP_COOKIE_DURATION,
              );
              await dispatch('getProfile');
              await dispatch('projectStore/getProject', undefined, { root: true });
              commit('SET_IS_LOGGED');
            }).catch((error) => {
              // eslint-disable-next-line no-console
              console.error('error', error);
            });
        }
        return loginError();
      }).catch(() => loginError()).finally(() => {
        commit('UNSET_IS_LOGIN_LOADING');
      });
  },
  logout({ commit }) {
    commit('UNSET_IS_LOGGED');
    cookie.deleteCookie(process.env.VUE_APP_COOKIE_NAME_AUTH);
    cookie.deleteCookie(process.env.VUE_APP_COOKIE_NAME_PROJECT_ID);
  },
  autoLogin({ commit }, { projectToken, authKey }) {
    const backendConnector = Connector.getInstance();
    cookie.deleteCookie(process.env.VUE_APP_COOKIE_NAME_AUTH);
    cookie.deleteCookie(process.env.VUE_APP_COOKIE_NAME_PROJECT_ID);
    commit('SET_IS_LOGIN_LOADING');
    return new Promise((resolve, reject) => {
      backendConnector
        .autoLogin(authKey, projectToken)
        .then(async (bearer) => {
          if (bearer !== '') {
            backendConnector
              .setProjectToken(projectToken);
            cookie.setCookie(
              process.env.VUE_APP_COOKIE_NAME_AUTH,
              bearer,
              process.env.VUE_APP_COOKIE_DURATION,
            );
            cookie.setCookie(
              process.env.VUE_APP_COOKIE_NAME_PROJECT_ID,
              projectToken,
              process.env.VUE_APP_COOKIE_DURATION,
            );
            commit('SET_IS_LOGGED');
            resolve(true);
          }
          resolve(false);
        })
        .catch((error) => {
          loginError();
          reject(error);
        })
        .finally(() => {
          commit('UNSET_IS_LOGIN_LOADING');
        });
    });
  },
};

const getters = {
  isLogged: state => state.isLogged,
  isLoginLoading: state => state.isLoginLoading,
  profile: state => state.profile,
  isPostPasswordLoading: state => state.isPasswordLoading,
};

const mutations = {
  TOGGLE_IS_PASSWORD_LOADING(state) {
    state.isPasswordLoading = !state.isPasswordLoading;
  },
  SET_PROFILE(state, profile) {
    state.profile.created_password = profile.created_password;
    state.profile.email = profile.email;
    state.profile.is_minarm = profile.is_minarm;
  },
  SET_IS_LOGGED(state) {
    state.isLogged = true;
  },
  UNSET_IS_LOGGED(state) {
    state.isLogged = false;
  },
  SET_IS_LOGIN_LOADING(state) {
    state.isLoginLoading = true;
  },
  UNSET_IS_LOGIN_LOADING(state) {
    state.isLoginLoading = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
